<div class="content">
    <article>
        <h2 class="heading-underline">
            <div class="back-button" (click)="goToApp(DataToolsApps.DATARULES)">
                <i class="bhi-previous"></i>
                <span>Back to DataRules</span>
            </div>
            Review and revert history of rules run
        </h2>
        <table mat-table
               [dataSource]="statsDataSource"
               id="history-table"
               class="table-striped row-highlight"
               matSort
               [ngClass]="{'no-tasks' : statsDataSource.data.length === 0}">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name of rule</th>
                <td mat-cell *matCellDef="let stat" [ngClass]="{'reverted' : stat.state === TaskState.ROLLED_BACK}">
                  <i *ngIf="stat.scheduledFrequency && schedulingEnabled" class="material-icons notranslate alarm" [matTooltip]="'Rule currently scheduled'" matTooltipShowDelay="500">alarm</i>
                  <i *ngIf="foldersEnabled() && stat.isArchived" class="material-icons-outlined notranslate archive-badge" matTooltip="This rule has been archived" [matTooltipShowDelay]="500" matTooltipPosition="above">inventory_2</i>
                    {{getStatDisplayName(stat)}}
                  <span *ngIf="stat.scheduledFrequency && schedulingEnabled" class="run-every">RUNS EVERY {{stat.scheduledFrequency | TransformRunFrequency}}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="entity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Entity</th>
                <td mat-cell *matCellDef="let stat"
                    [ngClass]="{'reverted' : stat.state === TaskState.ROLLED_BACK}"> {{stat.entity }} <!-- TODO: missing label - get from model? --> </td>
            </ng-container>
            <ng-container matColumnDef="userId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>User ID</th>
                <td mat-cell *matCellDef="let stat"
                    [ngClass]="{'reverted' : stat.state === TaskState.ROLLED_BACK}"> {{stat.userId}} </td>
            </ng-container>
            <ng-container matColumnDef="userName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>User Name</th>
                <td mat-cell *matCellDef="let stat"
                    [ngClass]="{'reverted' : stat.state === TaskState.ROLLED_BACK}"> {{stat.userName || 'N/A'}} </td>
            </ng-container>
            <ng-container matColumnDef="timesRun">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>No. of times run</th>
                <td mat-cell *matCellDef="let stat"> {{stat.timesRun}} </td>
            </ng-container>
            <ng-container matColumnDef="state">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
                <td mat-cell *matCellDef="let stat"
                    [ngClass]="{'reverted' : stat.state === TaskState.ROLLED_BACK}">
                    <span>{{TaskState[stat.state]}}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="startTime">
                <th mat-header-cell class="grey-header" *matHeaderCellDef mat-sort-header>Date & time of execution</th>
                <td mat-cell *matCellDef="let stat"
                    [ngClass]="{'reverted' : stat.state === TaskState.ROLLED_BACK}"> {{stat.startTime | date:'medium'}} </td>
            </ng-container>
          <ng-container matColumnDef="totalRecords">
            <th mat-header-cell class="grey-header numeric-cell" *matHeaderCellDef mat-sort-header>Found (Total)</th>
            <td mat-cell class="numeric-cell" *matCellDef="let stat">{{stat.totalRecords}}</td>
          </ng-container>
            <ng-container matColumnDef="recordsProcessed">
                <th mat-header-cell class="grey-header numeric-cell" *matHeaderCellDef mat-sort-header>Updated</th>
                <td mat-cell class="numeric-cell" *matCellDef="let stat">{{stat.recordsProcessed}}</td>
            </ng-container>
            <ng-container matColumnDef="noUpdateRequired">
                <th mat-header-cell class="grey-header numeric-cell" *matHeaderCellDef mat-sort-header>No Update Required</th>
                <td mat-cell class="numeric-cell" *matCellDef="let stat">{{stat.noUpdateRequired ?? '-'}}</td>
            </ng-container>
            <ng-container matColumnDef="recordsNotReached">
                <th mat-header-cell class="grey-header numeric-cell" *matHeaderCellDef mat-sort-header>Not Reached</th>
                <td mat-cell class="numeric-cell" *matCellDef="let stat">
                    <span *ngIf="stat.stoppedOnLimit; else noLimitStop"
                          [matTooltip]="'This run stopped on its record update limit of ' + stat.recordUpdateLimit"
                          matTooltipShowDelay="500">{{stat.recordsNotReached}} <i class="material-icons notranslate">info_outline</i></span>
                    <ng-template #noLimitStop>-</ng-template>
                </td>
            </ng-container>
            <ng-container matColumnDef="recordsFailed">
                <th mat-header-cell class="grey-header numeric-cell" *matHeaderCellDef mat-sort-header>Failed</th>
                <td mat-cell class="numeric-cell" *matCellDef="let stat"
                    [ngClass]="{'red' : stat.recordsFailed > 0}">{{stat.recordsFailed}} </td>
            </ng-container>
            <ng-container matColumnDef="ruleLink">
                <th mat-header-cell class="grey-header" *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let stat">
                    <i *ngIf="!stat.isDeleted" (click)="goToRule(stat)" aria-label="Open in DataRules"
                       matTooltip="Open in DataRules" class="history-rule-link">
                        <mat-icon>open_in_new</mat-icon>
                    </i>
                </td>
            </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let stat; columns: displayedColumns;"
          class="mat-row"
          [class.archived-row]="foldersEnabled() && stat.isArchived"
          (click)="tasksDialog(stat.ruleId, getStatDisplayName(stat), stat.timesRun)">{{stat}}
      </tr>
    </table>
    <app-skeleton *ngIf="loading" [style]="'big-row-table'" [count]="5"></app-skeleton>
    <div *ngIf="statsDataSource.data.length === 0 && !loading" class="no-results">
      No rules have been run
    </div>
    <mat-paginator [pageSize]="10"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   [selectConfig]="pageSizeSelectConfig"
                   aria-label="Select page">
    </mat-paginator>
  </article>
</div>
